import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native'; // ou useRouter do Expo Router

export default function PWAStatusView() {
  const [isPWAInstalled, setIsPWAInstalled] = useState(false);
  const navigation = useNavigation(); // ou const router = useRouter();

  useEffect(() => {
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;

    setIsPWAInstalled(standalone);
  }, []);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        {isPWAInstalled
          ? 'Este aplicativo está instalado como PWA ✅'
          : 'Este aplicativo está sendo executado no navegador 🌐'}
      </Text>

      <Text
        style={styles.laterButtonText}
        allowFontScaling={false}
        onPress={() => navigation.goBack()}
      >
        Voltar pra home
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  title: {
    fontSize: 20,
    textAlign: 'center',
    marginBottom: 40,
  },
  laterButtonText: {
    fontSize: 16,
    color: '#007AFF',
    textDecorationLine: 'underline',
  },
});
